import {defineStore} from 'pinia';
import {ModuleListCode} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import listCodeAPI from '@/apis/di/listCodeAPI';
const listCodeStore = new BaseDictionaryStore(listCodeAPI);
export const useListCodeStore = defineStore(ModuleListCode, {
  state: () => ({
    ...listCodeStore.state,
    _config: {
      key: 'list_code_id',
      code: 'list_code_alias',
      name: 'list_code_name',
      table: 'di_list_code',
      quickFollow: 'active',
      moduleName: 'Mã thống kê',
      defaultSort: 'list_code_alias',
    },
    moduleName: ModuleListCode,
  }),
  actions: {...listCodeStore.action},
  getters: {
    ...listCodeStore.getters,
  },
});
